exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._3EgJDkelU3v8zHKkuEpIwi {\n  position: absolute;\n  top: 0;\n  left: -280px;\n  opacity: 0;\n  z-index: 100; }\n\nul._3EgJDkelU3v8zHKkuEpIwi,\nol._3EgJDkelU3v8zHKkuEpIwi {\n  list-style: none;\n  margin: 0;\n  padding: 0; }\n\n._16oIOtZCy8hM4x6veLDmmL {\n  left: 140px;\n  z-index: 100;\n  opacity: 1; }\n", "", {"version":3,"sources":["/codebuild/output/src374373112/src/src/side-drawer/_components/nav-box/nav-box.scss"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,OAAO;EACP,aAAa;EACb,WAAW;EACX,aAAa,EAAE;;AAEjB;;EAEE,iBAAiB;EACjB,UAAU;EACV,WAAW,EAAE;;AAEf;EACE,YAAY;EACZ,aAAa;EACb,WAAW,EAAE","file":"nav-box.scss","sourcesContent":[".navBox {\n  position: absolute;\n  top: 0;\n  left: -280px;\n  opacity: 0;\n  z-index: 100; }\n\nul.navBox,\nol.navBox {\n  list-style: none;\n  margin: 0;\n  padding: 0; }\n\n.visible {\n  left: 140px;\n  z-index: 100;\n  opacity: 1; }\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"navBox": "_3EgJDkelU3v8zHKkuEpIwi",
	"visible": "_16oIOtZCy8hM4x6veLDmmL"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/typings-for-css-modules-loader/lib?{"namedExport":true,"camelCase":true,"modules":true,"sourceMap":true,"importLoaders":2,"localIdentname":"[name]__[local]__[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js!./src/side-drawer/_components/nav-box/nav-box.scss
// module id = 1017
// module chunks = 9